import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import PropTypes from 'prop-types'
import { compose } from 'redux'

import { Modal as ModalV5 } from 'antd'
import Modal from 'antd-v3/es/modal'

import { isAuthenticated$, isManuallyLoggedOut$ } from 'src/store/modules/user'

const withAuthentication = (Component) => {
  function withAuthenticationWrapper(props) {
    const { isAuthenticated, isManuallyLoggedOut, location } = props

    if (isAuthenticated) {
      return <Component {...props} />
    }

    Modal.destroyAll()
    ModalV5.destroyAll()

    setTimeout(() => {
      document
        .querySelectorAll('div.ant-modal-root')
        .forEach((e) => e && e.parentNode && e?.remove())
    }, 100)

    return (
      <Redirect
        to={{
          pathname: '/auth/login',
          state: isManuallyLoggedOut
            ? undefined
            : {
                referrer:
                  location.pathname === '/actions/telemedicine/video-conference'
                    ? { ...location, pathname: '/' }
                    : location
              }
        }}
      />
    )
  }

  withAuthenticationWrapper.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    isManuallyLoggedOut: PropTypes.bool.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.shape({
        referrer: PropTypes.shape({
          pathname: PropTypes.string.isRequired
        }).isRequired
      })
    }).isRequired
  }

  return withAuthenticationWrapper
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated$(state),
  isManuallyLoggedOut: isManuallyLoggedOut$(state)
})

export default compose(connect(mapStateToProps), withAuthentication)
